import { defineComponent as w, computed as v, useAttrs as y, createBlock as C, openBlock as b, unref as r, normalizeStyle as k, normalizeClass as N, withCtx as a, createVNode as d, Transition as O, withDirectives as $, mergeProps as x, withKeys as B, renderSlot as m, vShow as S, normalizeProps as K, guardReactiveProps as M } from "vue";
import "@popperjs/core";
import { RevList as P } from "@ds/components/List";
import "@ds/components/ListItemInteractive";
import { RevPopover as R } from "@ds/components/Popover";
import { omit as z } from "../../utils/omit.js";
import { tw as s } from "../../utils/tailwind.js";
const V = /* @__PURE__ */ w({
  name: "RevContextualMenu",
  inheritAttrs: !1,
  __name: "ContextualMenu",
  props: {
    disabled: { type: Boolean, default: !1 },
    listClassNames: { default: "" },
    contentClassNames: { default: "" },
    modifiers: { default: void 0 },
    position: { default: "auto" },
    role: { default: "menu" },
    shouldHideOnClickOutside: { type: Boolean, default: !0 },
    shouldShowOnMount: { type: Boolean, default: !1 },
    triggerElementId: { default: void 0 }
  },
  emits: ["keydown"],
  setup(e) {
    const u = e, c = {
      role: "menuitem"
    }, f = v(() => z(y(), ["class", "style"]));
    function h(t, i) {
      t && i();
    }
    const g = (t) => {
      const i = t.split("-", 1)[0], o = {
        bottom: s`origin-top`,
        left: s`origin-right`,
        right: s`origin-left`,
        top: s`origin-bottom`
      }[i];
      return [
        s`bg-overlap-default-low shadow-long rounded-sm inline-block min-w-240 max-w-320 overflow-y-auto`,
        o,
        u.listClassNames
      ];
    };
    return (t, i) => (b(), C(r(R), {
      class: N(t.$attrs.class),
      "content-class-names": e.contentClassNames,
      modifiers: e.modifiers,
      position: e.position,
      "should-hide-on-click-outside": e.shouldHideOnClickOutside,
      "should-show-on-mount": e.shouldShowOnMount,
      style: k(t.$attrs.style),
      "trigger-element-id": e.triggerElementId
    }, {
      trigger: a((o) => [
        m(t.$slots, "trigger", K(M({ ...o, isOpen: o.isOpen && !e.disabled })))
      ]),
      content: a(({ hide: o, isOpen: n, position: p }) => [
        d(O, {
          appear: "",
          "enter-active-class": "motion-safe:duration-300 motion-safe:ease-out",
          "enter-from-class": "scale-0 opacity-0",
          "leave-active-class": "motion-safe:duration-300 motion-safe:ease-in",
          "leave-to-class": "scale-0 opacity-0"
        }, {
          default: a(() => [
            $(d(r(P), x({
              "aria-expanded": n && !e.disabled,
              class: g(p),
              "has-external-borders": !1,
              role: e.role
            }, f.value, {
              onKeydown: [
                (l) => t.$emit("keydown", l, o),
                B((l) => h(n, o), ["esc"])
              ]
            }), {
              default: a(() => [
                m(t.$slots, "items", {
                  attrs: c,
                  hide: o
                })
              ]),
              _: 2
            }, 1040, ["aria-expanded", "class", "role", "onKeydown"]), [
              [S, n && !e.disabled]
            ])
          ]),
          _: 2
        }, 1024)
      ]),
      _: 3
    }, 8, ["class", "content-class-names", "modifiers", "position", "should-hide-on-click-outside", "should-show-on-mount", "style", "trigger-element-id"]));
  }
});
export {
  V as default
};
